/**
 * COURE.HUB.DS.TransactionLog.Api
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { MessageSendingStatus } from './messageSendingStatus';

export interface HubBillingTransactionDto { 
    serviceId?: string;
    receiptId?: string;
    clientId?: string;
    operationCount?: number;
    routeName?: string;
    transactionRef?: string;
    messageId?: string;
    senderId?: string;
    destinationNumber?: string;
    originator?: string;
    messageContent?: string;
    aggregatorId?: string;
    createdDate?: Date;
    reason?: string;
    messageSendingStatus?: MessageSendingStatus;
}